// extracted by mini-css-extract-plugin
export default {"wrapper":"Editable_wrapper__k4Q5V","wrapper__input":"Editable_wrapper__input__RFJi+"};